import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useQuery } from "react-query";
import axios from "axios";

import "./Poll.scss";
import images from "../../../../../../../../../utilities/images/images";

const Poll = ({ streamingDetails, showPoll, setShowPoll }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchPolls();
  }, []);

  const handleClickPollOption = async (pollId, option) => {
    const data = {
      poll_id: pollId,
      option,
    };
    const response = await axios.post(
      "https://learning.motion.ac.in/motioneducation/api/v1/poll/vote",
      data,
    );

    console.log("resonse", response);
    if (response.data.status === 200) {
      fetchPolls();
    }
  };

  const fetchPolls = async () => {
    const data = {
      chat_room_id: streamingDetails.chatroom,
      // chat_room_id: 20646,
    };
    const response = await axios.post(
      "https://learning.motion.ac.in/motioneducation/api/v1/get/polls",
      data,
    );

    if (response.data.data.length > 0) {
      setData(response.data.data);
      setShowPoll(true);
    }
  };

  return (
    <Modal
      show={showPoll}
      dialogClassName="poll-modal"
      onHide={() => setShowPoll(false)}
      backdrop={false}
    >
      <Modal.Header closeButton>
        <div className="poll-header">
          {/* <div className="motion-logo"><img src={images.motionLogo} alt="motion-logo"/></div>
          <div className="motion-text">Motion</div>
          <span  className="line">|</span>
          <div className="poll-created-time">5 min ago</div>
          <span  className="line">|</span>
        <div className="total-poll-votes">4 votes</div> */}
          <div className="poll-text" style={{ marginRight: "10px" }}>
            {" "}
            Polls
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {data?.map((pollItem) => {
          return (
            <div className="poll-body-content">
              <div className="poll-question">{pollItem.question}</div>
              <ul className="poll-options">
                {pollItem.options.map((option) => {
                  return (
                    <li
                      className="poll-option"
                      onClick={() =>
                        handleClickPollOption(pollItem.poll_id, option.option)
                      }
                    >
                      <ProgressBar now={option.responsePercentages} />

                      <div
                        className="poll-option-label"
                        style={{
                          color:
                            option.responsePercentages > 0 ? "#121212" : "#FFF",
                        }}
                      >
                        {option.option}
                      </div>
                      <div
                        className="poll-percentage"
                        // style={{ left: `${option.responsePercentages + 3}% ` }}
                      >
                        {option.responsePercentages}%
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </Modal.Body>
    </Modal>
  );
};

export default Poll;
